import React from "react";
import { Quote, Star } from "lucide-react";
import { testimonials } from "../../mock";

const initials = (name) =>
  name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-20 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-gold font-semibold tracking-[0.2em] uppercase text-sm">
            Testimonials
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-navy mt-3">
            What People Are Saying
          </h2>
          <p className="mt-4 text-gray-600 text-lg">
            Approximately 96% of our clients who used our system changed their
            financial situation in a matter of weeks.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-7">
          {testimonials.map((t) => (
            <figure
              key={t.id}
              className="relative bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-lg transition-shadow"
            >
              <Quote className="h-10 w-10 text-gold/25 absolute top-6 right-6" />
              <div className="flex gap-0.5 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-gold text-gold" />
                ))}
              </div>
              <blockquote className="text-gray-700 leading-relaxed italic">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <div className="h-12 w-12 rounded-full bg-navy text-gold font-serif font-bold flex items-center justify-center">
                  {initials(t.name)}
                </div>
                <div>
                  <div className="font-semibold text-navy">{t.name}</div>
                  <div className="text-sm text-gray-500">
                    {t.location} · Client of RFL
                  </div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-12 bg-navy rounded-2xl p-8 sm:p-10 text-center">
          <h3 className="font-serif text-2xl font-bold text-gold">Our Guarantee</h3>
          <p className="mt-3 text-gray-300 max-w-3xl mx-auto leading-relaxed">
            We understand that you have placed your trust in us and we take that
            responsibility seriously. RFL is committed to quality, achieving
            results, and providing “5-star level” client support. We believe in
            teaching a man how to fish so he can feed himself for a lifetime.
          </p>
        </div>
      </div>
    </section>
  );
}
